import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";

function PrivateRoutes({ children, ...rest }) {
  const [isAuth, setisAuth]= useState(true)
  useEffect(()=> {
    const hasJWT = () => {
      console.log("5 sec")
      const sessionData = JSON.parse(localStorage.getItem("session"));
      const token = sessionData ? sessionData.accessToken : null;
      if (!token){
        setisAuth(false)
        return false;
  
      }
      try {
        const user = jwtDecode(token.replace("Bearer ", ""));
        if (new Date().getTime() > user.exp * 1000) {
          localStorage.removeItem("session");
          setisAuth(false)
          return false;
        }
        return true;
      } catch (error) {
        console.error("Invalid token:", error);
        localStorage.removeItem("session");
        setisAuth(false)
        return false;
      }
    };
    hasJWT();
    const intervalId = setInterval(hasJWT, 5000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Route
      {...rest}
      render={() =>
        isAuth ? (
          children
        ) : (
          <Redirect to="/signin" />
        )
      }
    />
  );
}

export default PrivateRoutes;
